import { Injectable } from '@angular/core';

interface CacheEntry<T = any> {
  data: T;
  timestamp: number;
  ttl: number; // milliseconds, 0 = no expiry
}

@Injectable({
  providedIn: 'root'
})
export class CacheService {

  private cache = new Map<string, CacheEntry>();

  // Limite conservador: 50 entradas maximo (cada schema/gfd pesa ~5-50KB, total < 2.5MB)
  private readonly MAX_ENTRIES = 50;

  get(key: string): any | null {
    const entry = this.cache.get(key);
    if (!entry) return null;

    if (entry.ttl > 0 && (Date.now() - entry.timestamp) > entry.ttl) {
      console.log(`[Cache] TTL expirado, eliminando: ${key}`);
      this.cache.delete(key);
      return null;
    }

    console.log(`[Cache] Usando cache para: ${key}`);
    return entry.data;
  }

  /**
   * @param ttl Time-to-live en milisegundos. 0 = sin expiracion (cache permanente).
   */
  set(key: string, data: any, ttl: number = 0): void {
    console.log(`[Cache] Cacheando data de: ${key}${ttl > 0 ? ` (TTL: ${ttl / 1000}s)` : ' (permanente)'}`);
    if (this.cache.size >= this.MAX_ENTRIES) {
      // Eliminar la entrada mas antigua
      const oldestKey = this.cache.keys().next().value;
      this.cache.delete(oldestKey);
    }

    this.cache.set(key, { data, timestamp: Date.now(), ttl });
  }

  /** Invalida entradas que coincidan con un prefijo */
  invalidateByPrefix(prefix: string): void {
    for (const key of this.cache.keys()) {
      if (key.startsWith(prefix)) {
        console.log(`[Cache] Invalidando: ${key}`);
        this.cache.delete(key);
      }
    }
  }

  /** Invalida una key especifica */
  invalidate(key: string): void {
    this.cache.delete(key);
  }

  /** Limpia todo el cache */
  clear(): void {
    this.cache.clear();
  }

  /** Cantidad de entradas actualmente en cache */
  get size(): number {
    return this.cache.size;
  }
}

